var $23a92651c6957668$exports = {};
$23a92651c6957668$exports = {
    "alpha": `Alfa`,
    "blue": `Mavi`,
    "brightness": `Parlakl\u{131}k`,
    "green": `Ye\u{15F}il`,
    "hue": `Ton`,
    "lightness": `Canl\u{131}l\u{131}k`,
    "red": `K\u{131}rm\u{131}z\u{131}`,
    "saturation": `Doygunluk`
};


export {$23a92651c6957668$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
